export function hasRemoteFailures(remoteFailedFileCount) {
  return remoteFailedFileCount > 0;
}

export function getReadyToSubmit(completionSummary, remoteFailedFileCount) {
  return Boolean(completionSummary?.readyToSubmit) && !hasRemoteFailures(remoteFailedFileCount);
}

export function getOverallStatus(completionSummary, remoteFailedFileCount) {
  const completionOverallStatus = completionSummary?.overallStatus;
  return hasRemoteFailures(remoteFailedFileCount) && completionOverallStatus !== 'uploading'
    ? 'error'
    : completionOverallStatus;
}
